export class TransfertHeadcountSettingsModel {
  typeEffectifSource: number
  typeEffectifTarget: number
  overrideMode: boolean
  dateStart: Date
  dateEnd: Date
  cmcrplcdateIds: number[]
}
